<template>
  <div class="swiper-container myswiper">
    <div class="swiper-wrapper">
      <slot name="swipper-item"></slot>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: "imgSwipper",
  mounted() {
    new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: false, //允许分页点击跳转
      },
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  },
};
</script>

<style>
/* 修改pagination指示点的颜色 */
.swiper-container .swiper-pagination-bullet {
  width: 0.9rem;
  height: 0.9rem;
  background: #ffffff;
  border-radius: 50%;
  opacity: 1;
}

.swiper-container .swiper-pagination-bullet-active {
  opacity: 1;
  background: #020e62;
}

.myswiper {
  width: 100%;
  /* height: 59.375rem; */
  height: 46.875rem;
  overflow: hidden;
}

.bannerItem {
  background-size: cover;
  height: 100%;
}

/* .myswiper img {
  width: 100%;
  height: 100%;
} */

@media (min-width: 1200px) and (max-width: 1700px) {
  .myswiper {
    height: 43rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.7rem;
    height: 0.7rem;
  }
}

@media (min-width: 1021px) and (max-width: 1199px) {
  .myswiper {
    height: 39.2rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.6rem;
    height: 0.6rem;
  }
}

@media (min-width: 980px) and (max-width: 1020px) {
  .myswiper {
    height: 36rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.6rem;
    height: 0.6rem;
  }
}

@media (min-width: 901px) and (max-width: 979px) {
  .myswiper {
    height: 33rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.6rem;
    height: 0.6rem;
  }
}

@media (min-width: 801px) and (max-width: 900px) {
  .myswiper {
    height: 28rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.6rem;
    height: 0.6rem;
  }
}

@media (min-width: 500px) and (max-width: 800px) {
  .myswiper {
    height: 18rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.5rem;
    height: 0.5rem;
  }
}

@media (min-width: 0px) and (max-width: 499px) {
  .myswiper {
    height: 14rem !important;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 0.5rem;
    height: 0.5rem;
  }
}
</style>
